import { posthogClient } from 'lib/analytics/posthog'

import { getStore } from '@/store'

import { getBuilderSessionId, qrTypeAtom } from './generatorState'
import { TGeneratorStep } from './generatorTypes'

export const STEP_TO_INDEX: Record<TGeneratorStep, number> = {
	type: 1,
	content: 2,
	design: 3,
}

export const STEP_TO_NAME: Record<TGeneratorStep, string> = {
	type: 'choose_type',
	content: 'add_content',
	design: 'customize_design',
}

// MYQRCODE-10778 AC#13: every builder event carries builder_session_id and
// qr_type by default. Pass qr_type explicitly only when the event refers to
// a different type than the one currently selected (e.g. builder_view_badge,
// which reports the badged card, not the selected type).
export const captureBuilderEvent = (
	eventName: string,
	properties: Record<string, unknown> = {},
) => {
	posthogClient.capture(eventName, {
		builder_session_id: getBuilderSessionId(),
		qr_type: getStore().get(qrTypeAtom),
		...properties,
	})
}
